// Copyright (c) 2017 Deere & Company

import t from 'tcomb';

const SapEnvironment = t.struct({
    defaultVal: t.Bool,
    name: t.String
}, {
    name: 'SapEnvironment',
    strict: true
});

export const getDefaultState = () => new SapEnvironment({
    defaultVal: false,
    name: ''
});

export default SapEnvironment;



// WEBPACK FOOTER //
// ./src/shared/models/sap-environment.js